"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const remark_parse_1 = __importDefault(require("remark-parse"));
const remark_stringify_1 = __importDefault(require("remark-stringify"));
require("requestidlecallback");
const unified_1 = __importDefault(require("unified"));
/**
 * Parse markdown and chunk cells separated by the Thematic break. https://spec.commonmark.org/0.29/#thematic-breaks
 * If code block is top of the cell, it becomes the Code Cell, only 1 block including.
 * Others will merge. It become the Text Cell.
 * @param text Markdown text
 */
function cellify(text) {
    const children = blockify(text);
    // Chunking each nodes
    return Array.from(chunk(children));
}
exports.cellify = cellify;
function* chunk(nodes) {
    let chunkNum = 0;
    let textCellBuffer = [];
    for (let index = 0; index < nodes.length; index++) {
        const current = nodes[index], next = nodes[index + 1];
        if (!current)
            break;
        if (current.type === 'code' && textCellBuffer.length === 0) {
            yield {
                id: '' + chunkNum++,
                type: 'code',
                value: current.value,
                lang: current.lang,
                meta: current.meta
            };
            continue;
        }
        if (current.type !== 'thematicBreak') {
            textCellBuffer.push(current);
        }
        if ((!next || next.type === 'thematicBreak') && textCellBuffer.length > 0) {
            yield {
                id: '' + chunkNum++,
                type: 'text',
                value: unified_1.default()
                    .use(remark_stringify_1.default)
                    .stringify({
                    type: 'root',
                    children: textCellBuffer
                })
                    .trimRight(),
                nodes: textCellBuffer
            };
            textCellBuffer = [];
        }
    }
    return chunkNum;
}
/**
 * Parse text written in Markdown and return children of root node as an array.
 * @param text Markdown text
 */
function blockify(text) {
    const root = unified_1.default()
        .use(remark_parse_1.default)
        .parse(text);
    if (root.type !== 'root' || !Array.isArray(root.children)) {
        console.error(text);
        throw new Error('Invalid markdown. See console');
    }
    return root.children;
}
exports.blockify = blockify;
function htmlify(nodes) {
    const html = unified_1.default()
        .use(remark_parse_1.default)
        .use(require('remark-rehype'))
        .runSync({
        type: 'root',
        children: nodes
    });
    const __html = unified_1.default()
        .use(require('rehype-sanitize'))
        .use(require('rehype-stringify'))
        .stringify(html);
    return { __html };
}
exports.htmlify = htmlify;
function markdownify(nodes) {
    return unified_1.default()
        .use(remark_stringify_1.default)
        .stringify({
        type: 'root',
        children: nodes
    });
}
exports.markdownify = markdownify;
function md2html(text) {
    const __html = unified_1.default()
        .use(remark_parse_1.default)
        .use(require('remark-rehype'))
        .use(require('rehype-sanitize'))
        .use(require('rehype-stringify'))
        .processSync(text)
        .toString();
    return { __html };
}
exports.md2html = md2html;
